import { useEffect, useRef, useState } from "react";
import { useTranslate } from "@refinedev/core";
import { TDot, ThinkingWrap, TLabel } from "./Autopilot.styled";
import { THINKING_LABEL_KEYS } from "./constants";

export const ThinkingIndicator: React.FC = () => {
  const t = useTranslate();
  const [visible, setVisible] = useState(true);
  const [displayed, setDisplayed] = useState(t(THINKING_LABEL_KEYS[0]));
  const indexRef = useRef(0);

  useEffect(() => {
    let innerTimeout: ReturnType<typeof setTimeout>;
    const iv = setInterval(() => {
      setVisible(false);
      innerTimeout = setTimeout(() => {
        let next: number;
        do {
          next =
            crypto.getRandomValues(new Uint32Array(1))[0] %
            THINKING_LABEL_KEYS.length;
        } while (next === indexRef.current && THINKING_LABEL_KEYS.length > 1);
        indexRef.current = next;
        setDisplayed(t(THINKING_LABEL_KEYS[next]));
        setVisible(true);
      }, 300);
    }, 2500);
    return () => {
      clearInterval(iv);
      clearTimeout(innerTimeout);
    };
  }, [t]);

  return (
    <ThinkingWrap>
      <TDot $delay={0} />
      <TDot $delay={150} />
      <TDot $delay={300} />
      <TLabel $visible={visible}>{displayed}...</TLabel>
    </ThinkingWrap>
  );
};
